import React from 'react';

import { getTranslation } from 'helpers/getTranslation';

import { Typography } from 'components/shared/Typography';
import { DatePickerInput } from 'components/shared/DatePickerInput';

import styles from './CuratorReportAccessFilter.module.scss';

const CuratorReportAccessFilter = ({
  accessFrom,
  accessTo,
  onAccessFromChange,
  onAccessToChange,
}: {
  accessFrom: string;
  accessTo: string;
  onAccessFromChange: (value: string) => void;
  onAccessToChange: (value: string) => void;
}) => (
  <div className={styles.root}>
    <div className={styles.field}>
      <Typography
        className={styles.label}
        variant="caption"
        mode="compact"
      >
        {getTranslation('school_curator_report_page.access_filter.from')}
      </Typography>
      <DatePickerInput
        className={styles.input}
        value={accessFrom}
        onChange={onAccessFromChange}
      />
    </div>
    <div className={styles.field}>
      <Typography
        className={styles.label}
        variant="caption"
        mode="compact"
      >
        {getTranslation('school_curator_report_page.access_filter.to')}
      </Typography>
      <DatePickerInput
        className={styles.input}
        value={accessTo}
        onChange={onAccessToChange}
      />
    </div>
  </div>
);

export default React.memo(CuratorReportAccessFilter) as any;
